import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/mobile/close.png';
import _imports_1 from '../assets/mobile/jiahao.png';
const _withScopeId = n => (_pushScopeId("data-v-33c3f4d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "body"
};
const _hoisted_2 = {
  key: 0,
  class: "footer"
};
const _hoisted_3 = {
  class: "footer-top"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "logo"
};
const _hoisted_6 = {
  alt: "钧舵机器人"
};
const _hoisted_7 = {
  class: "companyTel"
};
const _hoisted_8 = {
  key: 0,
  class: "label"
};
const _hoisted_9 = {
  key: 1,
  class: "label"
};
const _hoisted_10 = {
  key: 2,
  class: "label"
};
const _hoisted_11 = {
  key: 3,
  class: "label"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:0512-63025073",
  class: "toPhoneStyle"
}, "0512-63025073")], -1));
const _hoisted_13 = {
  class: "saleTel"
};
const _hoisted_14 = {
  key: 0,
  class: "label"
};
const _hoisted_15 = {
  key: 1,
  class: "label"
};
const _hoisted_16 = {
  key: 2,
  class: "label"
};
const _hoisted_17 = {
  key: 3,
  class: "label"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:0512-63667858",
  class: "toPhoneStyle"
}, "0512-63667858")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content last"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:18962472921",
  class: "toPhoneStyle"
}, "18962472921")], -1));
const _hoisted_20 = {
  class: "right"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "list"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "modebox"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "list"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  key: 0,
  class: "beian"
};
const _hoisted_29 = {
  key: 1,
  class: "beian"
};
const _hoisted_30 = {
  key: 2,
  class: "beian"
};
const _hoisted_31 = {
  key: 3,
  class: "beian"
};
const _hoisted_32 = {
  key: 1,
  class: "footerAreaMb"
};
const _hoisted_33 = {
  class: "footerMb"
};
const _hoisted_34 = {
  class: "leftAreaMb"
};
const _hoisted_35 = {
  class: "logoMb"
};
const _hoisted_36 = {
  alt: ""
};
const _hoisted_37 = {
  key: 0,
  class: "bottomMb"
};
const _hoisted_38 = {
  key: 1,
  class: "bottomMb"
};
const _hoisted_39 = {
  key: 2,
  class: "bottomMb"
};
const _hoisted_40 = {
  key: 3,
  class: "bottomMb"
};
const _hoisted_41 = {
  class: "rightAreaMb"
};
const _hoisted_42 = {
  class: "companyTel"
};
const _hoisted_43 = {
  key: 0,
  class: "label"
};
const _hoisted_44 = {
  key: 1,
  class: "label"
};
const _hoisted_45 = {
  key: 2,
  class: "label"
};
const _hoisted_46 = {
  key: 3,
  class: "label"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content mb"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63025073"
}, "0512-63025073")], -1));
const _hoisted_48 = {
  class: "saleTel"
};
const _hoisted_49 = {
  key: 0,
  class: "label"
};
const _hoisted_50 = {
  key: 1,
  class: "label"
};
const _hoisted_51 = {
  key: 2,
  class: "label"
};
const _hoisted_52 = {
  key: 3,
  class: "label"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63667858"
}, "0512-63667858")], -1));
const _hoisted_54 = {
  key: 4,
  class: "content last"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "tel:18962472921",
  class: "toPhoneStyle"
}, "18962472921", -1));
const _hoisted_56 = [_hoisted_55];
const _hoisted_57 = {
  key: 5,
  class: "label"
};
const _hoisted_58 = {
  key: 7,
  class: "label"
};
const _hoisted_59 = {
  key: 9,
  class: "label"
};
const _hoisted_60 = {
  class: "listAreaMb"
};
const _hoisted_61 = {
  class: "iconMb"
};
const _hoisted_62 = ["onClick"];
const _hoisted_63 = {
  key: 0,
  class: "iconImgMb"
};
const _hoisted_64 = {
  key: 0,
  src: _imports_0,
  alt: "关闭"
};
const _hoisted_65 = {
  key: 1,
  src: _imports_1,
  alt: "+"
};
const _hoisted_66 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _directive_img_lazy = _resolveDirective("img-lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.ispc ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_img_lazy, $setup.language == 'en' ? $setup.footerLogoEn : $setup.footerLogo]])]), _createElementVNode("div", _hoisted_7, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "公司电话:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Company phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "TEL:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_11, "회사 전화:")) : _createCommentVNode("", true), _hoisted_12]), _createElementVNode("div", _hoisted_13, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_14, "销售热线:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Sales phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_16, "ホットライン:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_17, "판매문의 전화:")) : _createCommentVNode("", true), _hoisted_18, _hoisted_19])]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newNavList1, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mode",
      key: index
    }, [_createElementVNode("div", {
      class: "title",
      onClick: $event => $setup.chooseNav(item.navPath)
    }, _toDisplayString(item.navName), 9, _hoisted_21), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
      return _openBlock(), _createElementBlock("div", {
        key: item1.id,
        class: "item",
        onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
      }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_23);
    }), 128))])]);
  }), 128)), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newNavList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mode",
      key: index
    }, [_createElementVNode("div", {
      class: "title",
      style: {
        "margin-bottom": "0px"
      },
      onClick: $event => $setup.chooseNav(item.navPath)
    }, _toDisplayString(item.navName), 9, _hoisted_25), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
      return _openBlock(), _createElementBlock("div", {
        key: item1.id,
        class: "item",
        onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
      }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_27);
    }), 128))])]);
  }), 128))])])]), $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_28, " copyright（©）2022. 苏州钧舵机器人有限公司 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_29, " copyright（©）2022. Suzhou Jodell Robotics Ltd. Co. 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_30, " copyright（©）2022. 蘇州Jodell Robotics株式会社 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_31, " copyright（©）2022. 쑤저우 조델 로보틱스 유한회사 苏ICP备18070625号-1 ")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_withDirectives(_createElementVNode("img", _hoisted_36, null, 512), [[_directive_img_lazy, $setup.language == 'en' ? $setup.footerLogoEn : $setup.footerLogo]])]), $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 全国代理商火热招募中… ")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Sincerely looking for agents across the world… ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 全国各地の代理店を熱烈に募集中… ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 글로벌 에이전트를 열렬히 찾고 있습니다… ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_43, "公司电话:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Company phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_45, "TEL:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_46, "회사 전화:")) : _createCommentVNode("", true), _hoisted_47]), _createElementVNode("div", _hoisted_48, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_49, "销售热线:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Sales phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_51, "ホットライン:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_52, "판매문의 전화:")) : _createCommentVNode("", true), _hoisted_53, $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56)) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Email:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "content last",
    onClick: _cache[0] || (_cache[0] = $event => $setup.toEmail())
  }, " liuz@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_58, "メールボックス:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", {
    key: 8,
    class: "content last",
    onClick: _cache[1] || (_cache[1] = $event => $setup.toEmail())
  }, " liuz@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_59, "메일박스:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", {
    key: 10,
    class: "content last",
    onClick: _cache[2] || (_cache[2] = $event => $setup.toEmail())
  }, " liuz@jodell.cn ")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_60, [_createVNode(_component_el_collapse, {
    class: "listMb",
    accordion: "",
    modelValue: $setup.activeName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.activeName = $event),
    onChange: $setup.handleChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navlistMb, (item, index) => {
      return _openBlock(), _createBlock(_component_el_collapse_item, {
        name: index,
        class: "navMb",
        key: index,
        disabled: item.navChild.length === 0
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", {
          style: {
            "height": "100%",
            "display": "inline-block"
          },
          onClick: $event => $setup.chooseNavMb($event, item.navPath)
        }, _toDisplayString(item.navName), 9, _hoisted_62), item.navChild.length !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_63, [$setup.activeName == index ? (_openBlock(), _createElementBlock("img", _hoisted_64)) : (_openBlock(), _createElementBlock("img", _hoisted_65))])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
          return _openBlock(), _createElementBlock("div", {
            key: item1.id,
            class: "itemMb",
            onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
          }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_66);
        }), 128))]),
        _: 2
      }, 1032, ["name", "disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]))]);
}